import React, { useState, useEffect, use } from   'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button, Form, Row, Col, FormGroup, ButtonGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import CargandoSpinner from '../Utils/CargandoSpinner';
import FormularioLineasPE from './FormularioLineasPE';
import FormularioProyectos from './FormularioProyectos';
import * as XLSX from 'xlsx';

export default function Reportes() {
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [metodosRecoleccion, setMetodosRecoleccion] = useState([]);
    const [proyectoEncuesta, setProyectoEncuesta] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [fichasPersonas, setFichasPersonas] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const defaultValues = {
        id: 0,
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
                defaultValues: defaultValues
            }
        );
    const idFicha = Number(watch('id')) || 0;
    
    async function descargarReporteEncuestador() {
        setCargando(true);
        try {
            const response = await apiService.get('/ssv/reportes/downloadReporteEncuestador', token, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'encuestador.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error al descargar el reporte por encuestador:', error);
        }
        finally {
            setCargando(false);
        }
    }

    async function descargarIdFicha() {
        setCargando(true);
        try {
            const response = await apiService.get('/encuestassv/reportes/consultarfichasssv', token, );
            const datos = response.data.fichasSSV;
            const titulos = response.data.titulos;
            const ws = XLSX.utils.json_to_sheet(datos);
            const wb = XLSX.utils.book_new();
            XLSX.utils.sheet_add_aoa(ws, [titulos], { origin: 0 });
            XLSX.utils.book_append_sheet(wb, ws, "IdFicha");
            XLSX.writeFile(wb, 'id_ficha.xlsx');
        } catch (error) {
            console.error('Error al descargar el reporte por id ficha:', error);
        } finally {
            setCargando(false);
        }
    }

    async function descargarHogar() {
        setCargando(true);
        try {
            const response = await apiService.get('/encuestassv/reportes/consultarhogarsssv', token, );
            const datos = response.data.hogaresSSV;
            const titulos = response.data.titulos;
            const ws = XLSX.utils.json_to_sheet(datos);
            XLSX.utils.sheet_add_aoa(ws, [titulos], { origin: 0 });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hogar");
            XLSX.writeFile(wb, 'hogar.xlsx');
        } catch (error) {
            console.error('Error al descargar el reporte por hogar:', error);
        } finally {
            setCargando(false);
        }
    }

    async function descargarPersonas() {
        setCargando(true);
        try {
            const response = await apiService.get('/encuestassv/reportes/consultarpersonasssv', token, );
            const datos = response.data.personasSSV;
            const titulos = response.data.titulos;
            const ws = XLSX.utils.json_to_sheet(datos);
            XLSX.utils.sheet_add_aoa(ws, [titulos], { origin: 0 });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Personas");
            XLSX.writeFile(wb, 'personas.xlsx');
        } catch (error) {
            console.error('Error al descargar el reporte por personas:', error);
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <Row className="mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Reportes</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">SSV Reportes</li>
                        </ol>
                    </div>
                    </Row>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <Row>
                        <Col md={6} lg={4} sm={6}>
                            <Card>
                                <Card.Header style={{backgroundColor: '#3c8dbc', color: 'white'}}>
                                    <i style={{fontSize: '170%'}}>ID Ficha</i>
                                </Card.Header>
                                <Card.Body>
                                    <h3 className="title">
                                        Generar planilla de
                                        <Button
                                            as="a"
                                            onClick={descargarIdFicha}
                                            size="sm"
                                            style={{ marginLeft: '8px' }}
                                        >
                                            ID Ficha
                                        </Button>
                                    </h3>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={4} sm={6}>
                            <Card>
                                <Card.Header style={{backgroundColor: '#3c8dbc', color: 'white'}}>
                                    <i style={{fontSize: '170%'}}>Hogar</i>
                                </Card.Header>
                                <Card.Body>
                                    <h3 className="title">Generar planilla 
                                        <Button
                                            as="a"
                                            onClick={descargarHogar}
                                            size="sm"
                                            style={{ marginLeft: '8px' }}
                                        >
                                            Hogar
                                        </Button>
                                    </h3>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={4} sm={6}>
                            <Card>
                                <Card.Header style={{backgroundColor: '#3c8dbc', color: 'white'}}>
                                    <i style={{fontSize: '170%'}}>Personas</i>
                                </Card.Header>
                                <Card.Body>
                                    <h3 className="title">Generar planilla 
                                        <Button
                                            as="a"
                                            onClick={descargarPersonas}
                                            size="sm"
                                            style={{ marginLeft: '8px' }}
                                        >
                                            Personas
                                        </Button>
                                    </h3>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} lg={4} sm={6}>
                            <Card>
                                <Card.Header style={{backgroundColor: '#3c8dbc', color: 'white'}}>
                                    <i style={{fontSize: '170%'}}>Reporte por encuestador</i>
                                </Card.Header>
                                <Card.Body>
                                    <h3 className="title">
                                        Generar planillas de 
                                        <Button
                                            as="a"
                                            onClick={descargarReporteEncuestador}
                                            size="sm"
                                            style={{ marginLeft: '8px' }}
                                        >
                                            Encuestador
                                        </Button>
                                    </h3>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <FormularioLineasPE />
                    <FormularioProyectos />
                    
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>            
        </div>
      
  )
  }